import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

export const searchAutoComplete = (subject, searchKey) => {
    const api = APIEndpoint.SEARCH_AUTO_COMPLETE + `/${subject}` + `?searchKey=${searchKey}`;
    const res = axiosInstance.get(api);
    return res;
};